export default __webpack_public_path__ + "static/media/idea-web-5.087b1575.png";